import React, { useState, useEffect } from 'react';
import { connectWallet } from './utils/wallet';
import Navbar from './components/Navbar';
import MiningControls from './components/MiningControls';
import Logs from './components/Logs';
import './App.css';

function App() {
  const [walletAddress, setWalletAddress] = useState("");
  const [nfts, setNFTs] = useState([]);
  const [mining, setMining] = useState(false);
  const [logs, setLogs] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (walletAddress) {
      // Fetch NFTs (simulate with dummy data)
      setNFTs([
        { name: "NFT 1", collection: "Art", imageUrl: "https://imgcdn.stablediffusionweb.com/2024/9/29/8b16f437-48a3-4ced-9c65-4907eaf69ab0.jpg" },
        { name: "NFT 2", collection: "Music", imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5VMm_-GZ0z63aJHr8wEyvq7G30ujNxWPsTy7PkdyG5A61VwLbUf3xC_1UJ0hU47Fpatk&usqp=CAU" },
        // More NFTs
      ]);
    }
  }, [walletAddress]);

  return (
    <div className="App">
      <Navbar walletAddress={walletAddress} connectWallet={connectWallet} setWalletAddress={setWalletAddress} setErrorMessage={setErrorMessage} />

      <MiningControls
        mining={mining}
        setMining={setMining}
        setLogs={setLogs}
        setErrorMessage={setErrorMessage}
        walletAddress={walletAddress}
      />

      <Logs
        mining={mining}
        setLogs={setLogs}
        logs={logs}       // <- make sure this is passed!
        nfts={nfts}
      />


      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

export default App;
